/**
 * Created by shaharshelly on 11/25/15.
 */
import IService from '../IService';

export default IService.extend({
  providers: {
    FACEBOOK: 'facebook',
    VIMEO: 'vimeo',
    YOUTUBE: 'google',
    TWITTER: 'twitter',
    INSTAGRAM: 'instagram',
    SLACK: 'slack',
    FRAMEIO: 'frameio',
  },

  providersUploadAPIMapping: {
    facebook: 'facebook',
    vimeo: 'vimeo',
    google: 'youtube',
    twitter: 'twitter',
    instagram: 'instagram',
  },

  scopes: {
    facebook: 'email,manage_pages, publish_pages,publish_actions,user_videos',
    vimeo: 'public private edit upload',
    google:
      'https://www.googleapis.com/auth/youtube.upload https://www.googleapis.com/auth/plus.me',
    twitter: '',
    instagram: 'public_content',
    slack: '',
  },

  initialize() {
    this.$ajax = null;
    this.cacheMap = new Map();
  },

  getUserAccounts({ cache } = {}) {
    if (app.xhrExpected(this.$ajax)) {
      this.$ajax.abort();
    }

    return this.get({
      endpoint: 'users/me/social',
      cache: !!cache,
    });
  },

  getUploadStatus(videoModel, video_status_id) {
    const promise = new $.Deferred();
    const videoId = videoModel.get('id');

    $.ajax({
      url: app.apiUrl(
        `/api/v1/stories/${videoId}/video/social/status/${video_status_id}`
      ),
      type: 'GET',

      error(response) {
        promise.reject(response);
      },

      contentType: 'application/json',
      success(response) {
        console.log('getUploadStatus response', response);
        promise.resolve(response);
      },
    });

    return promise;
  },

  _connect_do(provider) {
    const promise = new $.Deferred();

    $.ajax({
      url: app.authUrl(`/api/v1/social/connect/${provider}`),
      type: 'POST',
      xhrFields: { withCredentials: true },

      error: $.proxy(function (response) {
        promise.reject(response);
      }, this),

      contentType: 'application/json',
      success(response) {
        if (response.redirectUrl) {
          promise.resolve(response.redirectUrl);
        } else {
          promise.reject(response);
        }
      },
    });

    return promise;
  },

  connect(videoModel, provider) {
    const promise = new $.Deferred();
    let loginPage;

    window.addEventListener('message', receiveMessage, false);

    function receiveMessage(e) {
      // For Chrome, the origin property is in the event.originalEvent object.
      const origin = e.origin || e.originalEvent.origin;
      if (serverProfile.authUrl.indexOf(origin) < 0) {
        // not from our api server
        return;
      }

      console.log('socialProviderPostMessage response', e.data);
      window.removeEventListener('message', receiveMessage);
      if (loginPage) {
        loginPage.close();
      }

      if (!_.isEmpty(e.data.providerUserId)) {
        console.log(
          'connect success to provider:',
          provider,
          'id',
          e.data.providerUserId,
          videoModel ? videoModel.id + ' ' + videoModel.programmerId : ''
        );
        promise.resolve(e.data);
      } else if (!_.isEmpty(e.data.error_msg)) {
        const isCanceled = e.data.error_msg === 'access_denied';

        if (!isCanceled) {
          app.doctorController.report(
            'social connect failed:' + e.data.error_msg
          );
        }

        promise.reject({ isCanceled });
      } else {
        promise.reject();
      }
    }

    this._connect_do(provider)
      .done((popupUrl) => {
        loginPage = window.open(
          popupUrl,
          'socialPopupWindow',
          'width=600, height=400, scrollbars=yes'
        );
      })
      .fail(() => {
        promise.reject();
      });

    return promise;
  },
  /**
   * generic get
   * @param o {Object}
   * @return Promise
   */
  get(o) {
    o = Object.assign(
      {
        endpoint: '',
        params: {},
        cache: false,
        maxAge: app.TIME.HOUR,
      },
      o
    );

    const promise = new $.Deferred();

    // from cache
    if (o.cache && this.cacheMap.has(o.endpoint)) {
      const curDate = Date.now();
      const cacheValue = this.cacheMap.get(o.endpoint);

      if (cacheValue.time + o.maxAge >= curDate) {
        promise.resolve(cacheValue.response);
        return promise;
      }
    }

    // from server
    $.ajax({
      url: app.apiUrl(`/api/v1/${o.endpoint}`, o.params),
      type: 'GET',

      error(response) {
        promise.reject(response);
      },

      contentType: 'application/json',
      success: (response) => {
        console.log(`get success: ${o.endpoint}`, response);
        // always set new response to cache
        this.cacheMap.set(o.endpoint, {
          response,
          time: Date.now(),
        });
        promise.resolve(response);
      },
    });

    return promise;
  },

  post(o) {
    o = Object.assign(
      {
        endpoint: '',
        data: {},
        params: {},
      },
      o
    );

    const promise = new $.Deferred();

    this.$ajax = $.ajax({
      url: app.apiUrl(`/api/v1/${o.endpoint}`, o.params),
      type: 'POST',
      data: JSON.stringify(o.data),

      error(response) {
        promise.reject(response);
      },

      contentType: 'application/json',
      success(response) {
        console.log('response', response);
        promise.resolve(response);
      },
    }).always(() => {
      this.$ajax = null;
    });

    return promise;
  },

  getVideoUploads(videoId) {
    if (app.xhrExpected(this.$ajax)) {
      this.$ajax.abort();
    }

    const promise = new $.Deferred();

    this.$ajax = $.ajax({
      url: app.apiUrl(`/api/v1/producedStories/${videoId}/video/social`),
      type: 'GET',

      error(response) {
        promise.reject(response);
      },

      success(response) {
        console.log('response', response);
        promise.resolve(response);
      },
    });

    return promise;
  },

  upload(
    videoId,
    programmerId,
    provider,
    title,
    description,
    privacyStatus,
    targetId
  ) {
    if (_.isNull(title) || _.isUndefined(title)) {
      title = '';
    }
    if (_.isNull(description) || _.isUndefined(description)) {
      description = '';
    }
    const promise = new $.Deferred();
    const data = {
      programmerId: programmerId,
      title: title,
      description: description,
      targetId: targetId,
    };
    if (privacyStatus) {
      data.youtubePrivacyStatus = privacyStatus;
    }

    // todo: the upload needs provider name youtube instead of google
    provider = this.providersUploadAPIMapping[provider];

    if (app.xhrExpected(this.$ajax)) {
      this.$ajax.abort();
    }

    this.$ajax = $.ajax({
      url: app.apiUrl(`/api/v1/stories/${videoId}/video/social/${provider}`),
      type: 'POST',
      data: JSON.stringify(data),

      error(response) {
        // todo: should be moved to view !!
        if (provider === 'twitter' && response && response.status === 413) {
          app.dialog.error({
            title: app.culture.alert.TWITTER_VIDEO_TO_LONG,
            description: app.culture.alert.TWITTER_VIDEO_TO_LONG_DESC,
          });
        }

        promise.reject(response);
      },

      contentType: 'application/json',
      success(response) {
        console.log('response', response);
        promise.resolve(response);
      },
    }).always(() => {
      this.$ajax = null;
    });

    return promise;
  },

  uploadVideoModel(
    videoModel,
    provider,
    title,
    description,
    privacyStatus,
    targetId
  ) {
    return this.upload(
      videoModel.get('id'),
      videoModel.get('programmerId'),
      provider,
      title,
      description,
      privacyStatus,
      targetId
    );
  },

  connectAndUpload(videoModel, provider) {
    const promise = new $.Deferred();

    this.connect(videoModel, provider)
      .done(() => {
        this.uploadVideoModel(videoModel, provider)
          .done((response) => {
            promise.resolve(response);
          })
          .fail(() => {
            promise.reject();
          });
      })
      .fail(() => {
        promise.reject();
      });

    return promise;
  },
});
